/************************************
MODULE:         Tracking
WHAT IT DOES:   Provides with all functionality that relates to tracking
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var queue = [];

    function init() {
        initGatracking();
        initCallTracking();
        initGTagManagerTracking();
        trackQuote();

        setTimeout(sendQueue, 5000);

        $(window).bind("pageshow", unloadTrackingDone);
        $(window).on("load", trackAppearance);
    }

    function sendQueue() {
        if (!queue.length) return ;

        queue.forEach(function(arguments) {
            window.ga.apply(null, arguments);
        });
        queue = [];
    }

    function reInitLinksGatracking() {
        $(document).off('click', 'a.js-tracked');
        $(document).on('click', 'a.js-tracked', eventProcess);
        $(document).off('click change', '.js-track-dimension');
        $(document).on('click change', '.js-track-dimension', dimensionProcess);
        $(document).off('click', 'a.js-tracking-product');
        $(document).on('click', 'a.js-tracking-product', sendProductGA);
        $(document).off('click', 'a.js-tracking-cart');
        $(document).on('click', 'a.js-tracking-cart', sendCartGA);
    }

    function initGatracking() {
        $(document).on('change', '.js-tracking-label-update', updateTrackingLabel);

        $(document).on('click change', '.js-track-dimension', dimensionProcess);
        $(document).on('click', 'a.js-tracked, div.js-tracked, span.js-tracked, input[type=submit].js-tracked, button.js-tracked, input[type=text].js-datepicker.js-tracked', eventProcess);
        $(document).on('click', 'a.js-tracking-product', sendProductGA);
        $(document).on('click', 'a.js-tracking-cart', sendCartGA);
        $(document).on('keyup', 'input[type=text].js-tracked, input[type=email].js-tracked, input[type=tel].js-tracked, textarea.js-tracked', eventProcess);
        $(document).on('change', 'select.js-tracked, input[type=checkbox].js-tracked, input[type=radio].js-tracked', eventProcess);
        $(document).on('gatrack:send', '.js-track-postponed', eventProcess);
        $(document).on('gatrack:send', '.js-track-pageview-postponed', pageviewProcess);
        $(document).on('gatrack:senddata', sendGA);
    }

    function initGTagManagerTracking() {
        $(document).on('click', 'a.js-gtm-tracked, div.js-gtm-tracked, span.js-gtm-tracked, input[type=submit].js-gtm-tracked, button.js-gtm-tracked', eventGTagManagerProcess);
    }

    function unloadTrackingDone() {
        $('.js-tracking-done').removeClass('js-tracking-done');
        $('.js-tracking-pageview-done').removeClass('js-tracking-pageview-done');
    }

    function eventProcess(e) {
        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }

        var $control = $(this);
        sendBeaconFromNode($control);
    }

    function sendBeaconFromNode($element) {
        if ($element.hasClass('js-tracking-done')) {
            return;
        }

        sendGA(null, 'event', $element.attr('data-tracking-category'), $element.attr('data-tracking-action'), $element.attr('data-tracking-label'));

        if ($element.hasClass('js-additional-tracking')) {
            sendGA(null, 'event',
                $element.attr('data-tracking-additional-category'),
                $element.attr('data-tracking-additional-action'),
                $element.attr('data-tracking-additional-label'));
        }

        $element.addClass('js-tracking-done')
    }

    function trackAppearance() {
        $('.js-track-appearance:not(.js-tracking-done)').each(function(i, el) {
            sendBeaconFromNode($(el));
        })


    }

    function dimensionProcess(e) {
        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }
        var control = $(this);
        if (!control.hasClass('js-track-dimension')) {
            control = control.parents('.js-track-dimension');
        }
        if (control.hasClass('js-dimension-done')) return;
        generalGA(null, 'set', control.data('tracking-dimension-name'), control.data('tracking-dimension-value'));
        control.addClass('js-dimension-done');
    }

    function pageviewProcess(e) {
        var control = $(this);
        if (control.hasClass('js-tracking-pageview-done')) return;
        sendGA(null, 'pageview', control.attr('data-tracking-pageview-label'));
        control.addClass('js-tracking-pageview-done');
    }

    function sendGA() {
        if (arguments.length < 2)
            return;

        var newarguments = new Array('send');
        for (var i = 1, l = arguments.length; i < l; i++) {
            if (typeof arguments[i] != 'undefined')
                newarguments.push(arguments[i]);
        }

        safeGa.apply(window.ga, newarguments);
    }

    function generalGA() {
        if (typeof ga == 'undefined' || arguments.length < 2)
            return;

        var newarguments = new Array();
        for (var i = 1, l = arguments.length; i < l; i++) {
            if (typeof arguments[i] != 'undefined')
                newarguments.push(arguments[i]);
        }

        safeGa.apply(ga, newarguments);
    }

    function updateTrackingLabel(e) {
        var control = e.target,
            val = control.tagName.toLowerCase() === 'select' ? (!(control.options[control.selectedIndex].dataset.shortLabel) ? control.options[control.selectedIndex].text : control.options[control.selectedIndex].dataset.shortLabel) : control.value
            selector = control.getAttribute('data-label-update-selector'),
            $updateEls = selector ? $(selector) : $(control);

        for (var i = 0, l = $updateEls.length; i < l; i++) {
            var element = $updateEls[i],
                labelBase = element.getAttribute('data-tracking-label-base') || '%',
                newLabel = labelBase.replace(/\%/g, val);
            element.setAttribute('data-tracking-label', newLabel);
        }
        if ($updateEls.length) {
            unloadTrackingDone();
        }

    }

    function initCallTracking() {
        window.callTrackingCallback = function (formatted_number, mobile_number) {
            var phonesToReplace = $('.js-call-replace');
            for (var i = 0, l = phonesToReplace.length; i < l; i++) {
                var item = phonesToReplace.eq(i),
                    parent = item.parent();
                item.html(formatted_number);
                if (parent.is("a")) {
                    parent.attr("href", "tel:" + mobile_number);
                }
            }
        };

        if ($('body').hasClass('body-loaded')) {
            callTracking();
        } else {
            window.onload = callTracking;
        }
    }

    function callTracking() {
        if (typeof _googWcmGet != 'undefined' && typeof callTrackingCallback != 'undefined' && typeof trackingCallNumber != 'undefined') {
            _googWcmGet(callTrackingCallback, trackingCallNumber);
        }
    }

    function eventGTagManagerProcess(e) {
        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }

        var $control = $(this);
        if ($control.hasClass('js-gtm-tracking-done')) return;

        var data = $control.data();
        data["event"] = data["gtmEvent"];

        dataLayer.push(data);
        $control.addClass('js-gtm-tracking-done');
    }

    function trackQuote() {
        var $dataContainer = $('.js-track-quote');
        if (!$dataContainer.length) return;

        var eventData = $dataContainer.attr('data-gaevent');

        if (eventData) {
            dataLayer.push({ 'event': eventData });
        }
    }

    function sendProductGA(e) {

        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }
        var control = $(this);
        if (control.hasClass('js-tracking-done')) return;

        safeGa("require", "ec");
        safeGa("ec:addProduct", {
            id: control.attr('data-tracking-id'),
            name: control.attr('data-tracking-name'),
            position: control.attr('data-tracking-position')
        });
        safeGa("ec:setAction", "click", {
            list: control.attr('data-tracking-search-initiator')
        });
        safeGa("send", "event", control.attr('data-tracking-search-initiator'), "click", "");

        control.addClass('js-tracking-done');
    }

    function sendCartGA(e) {

        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }
        var control = $(this);
        if (control.hasClass('js-tracking-cart-done')) return;

        var trackingData = {
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'GBP',
                list: control.attr('data-enquiry-search-initiator'),
                add: {
                    products: [
                        {
                            id: control.attr('data-enquiry-siteid'),
                            name: control.attr('data-tracking-action')
                        }]
                }
            }
        };

        dataLayer.push(trackingData);

        control.addClass('js-tracking-cart-done');
    }

    function safeGa() {
        if (typeof window.ga === 'function') {
            sendQueue();
            window.ga.apply(null, arguments);
        } else {
            queue.push(arguments);
        }
    }

    return {
        init: init,
        reInitLinksGatracking: reInitLinksGatracking,
        safeGa: safeGa
    };
}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.gatracking.js
 ** module id = 12
 ** module chunks = 24
 **/